import { createMemo, Show } from 'solid-js';
import { sheet } from '../state/sheet';
import { checkDpi } from '../core/dpi';
import { handleExportPdf, handleExportPng } from './exportHandlers';
import { pdfExporting, pngExporting, activeView, setActiveView } from './uiState';
import { SegmentedControl } from './SegmentedControl';
import { ExportMenu } from './ExportMenu';

const VIEW_OPTIONS = [
  { value: 'slots', label: 'Slots' },
  { value: 'preview', label: 'Preview' },
] as const;

export function Header() {
  const filledCount = createMemo(() => sheet.slots.filter(s => s.image !== null).length);
  const lowDpiCount = createMemo(() =>
    sheet.slots.reduce((acc, s) => acc + (s.image && !checkDpi(s.image, s.fitTarget).ok ? 1 : 0), 0),
  );

  return (
    <div class="header">
      <div class="header-title">Badge Maker</div>
      <div class="header-segmented">
        <SegmentedControl
          value={activeView()}
          onChange={setActiveView}
          options={VIEW_OPTIONS}
        />
      </div>
      <div class="header-counters">
        <span>{filledCount()} / 15 filled</span>
        <Show when={lowDpiCount() > 0}>
          <span class="header-warning">{lowDpiCount()} ⚠ low DPI</span>
        </Show>
      </div>
      <div class="header-actions">
        <button
          type="button"
          class="btn btn-primary"
          disabled={pdfExporting()}
          onClick={() => void handleExportPdf()}
        >
          {pdfExporting() ? 'Generating…' : 'Export PDF'}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          disabled={pngExporting()}
          onClick={() => void handleExportPng()}
        >
          {pngExporting() ? 'Generating…' : 'Export PNG'}
        </button>
      </div>
      <div class="header-export-menu">
        <ExportMenu />
      </div>
    </div>
  );
}
